// Common
function board_make(project_id_query) {
    $('#home3 .card-body').html(
        '<div class="simple-radio" id="board_list"></div>'
    );
	let itemArray = [{
			name: "傷亡失蹤(EMIS速報表)",
			icon: "heart-broken",
			logid: "22",
			btnlayer: "invisible",
			btntable: "visible",
		}, {
			name: "案件統計(EMIS速報表)",
			icon: "phone-call",
			logid: "23",
			btnlayer: "invisible",
			btntable: "visible"
		}, {
			name: "疏散收容(EMIS速報表)",
			icon: "open-home",
			logid: "",
			btnlayer: "invisible",
			btntable: "visible"
		}, {
			name: "雨量站(氣象署)",
			icon:  "rain",
			logid: "30",
			btnlayer: "visible",
			btntable: "visible",
		}, {
			name: "土石流警戒(水保署)",
			icon:  "debris",
			logid: "24",
			btnlayer: "visible",
			btntable: "visible"
		}, {
			name: "淹水感知器(水利署)",
			icon:  "flood_sensor",
			logid: "",
			btnlayer: "visible",
			btntable: "visible"
		},  {
			name: "淹水感知器(車行地下道)",
			icon: "underpass",
			logid: "",
			btnlayer: "visible",
			btntable: "visible"
		}, {
			name: "抽水站(水利局)",
			icon:  "pump",
			logid: "25",
			btnlayer: "visible",
			btntable: "visible"
		}, {
			name: "移動抽水機(水利局)",
			icon:  "m_pumper",
			logid: "26",
			btnlayer: "visible",
			btntable: "visible"
		}, {
			name: "橫移門(水利局)",
			icon:  "water_door",
			logid: "31",
			btnlayer: "visible",
			btntable: "visible"
		},{
			name: "央管水位(水利署)",
			icon:  "water_stage",
			logid: "27",
			btnlayer: "visible",
			btntable: "visible"
		}, {
		// 	name: "市管水位(水利局)",
		// 	icon:  "water_stage_local",
		// 	logid: "28",
		// 	btnlayer: "visible",
		// 	btntable: "visible"
		// }, {
			name: "水庫洩洪(水利署)",
			icon:  "reservior",
			logid: "",
			btnlayer: "visible",
			btntable: "invisible"
		}, {
			name: "員山子分洪道(水利署)",
			icon:  "outflow",
			logid: "",
			btnlayer: "visible",
			btntable: "invisible"
		}, {
			name: "淹水警戒(水利署)",
			icon:  "flooding",
			logid: "29",
			btnlayer: "invisible",
			btntable: "visible"
		}, {
			name: "停班停課(人事室)",
			icon: "ban",
			logid: "",
			btnlayer: "invisible",
			btntable: "invisible"
		}, {
			name: "道路封閉(公路總局)",
			icon: "road-break",
			logid: "",
			btnlayer: "visible",
			btntable: "visible"
		}, {
			name: "維生管線(EMIC)",
			icon:  "flash",
			logid: "",
			btnlayer: "invisible",
			btntable: "visible"
		}],
		boardHtml = "",
		boardActiveIndex = 1
	itemArray.forEach(function(element, index){
		if ((element.name.match('EMIS') && project_id_query) || !element.name.match('EMIS')) {
			boardHtml +=
				`<div class="col-12 move_element">
					<div class="move_content" id="board_component_' + element.icon + '">
						<div class="move_content_text">
							<span class="move_content_text_title">${String(boardActiveIndex)}</span>
							<span class="move_content_text_main overflow-hidden"><img src="board_icon/${element.icon}.svg" width="50"></span>
							<span class="font-weight-bold">
								<span class="move_content_text_value">${element.name}</span>
								<i class="fas fa-question-circle ml-2 float-right" id="data_source_${element.icon}"></i>
								<i class="function-log fas fa-table ml-2 float-right ${element.btntable}" function-log-id="${element.logid}"></i>
								<i class="fas fa-map-marker-alt ml-2 float-right ${element.btnlayer}"></i>
							</span>
							<br>
							<span id="board_${element.icon}"></span>
						</div>
					</div>
				</div>`
			boardActiveIndex += 1
		}
    })
    $('#board_list').html(
    	'<div class="row">'+
	    	'<div id="board_title" class="col-12 text-center mt-1 d-none"><img class="align-bottom" src="logo3.png" height="50"><span class="font-weight-bold ml-2 title-text">防救災數據即時統計</span></div>' +
	    	'<div class="col-12 font-weight-bold pl-20p pr-20p">'+
		    	'<div class="move_content">'+
			    	// '<div class="invisible">1</div>'+
			    	'<div class="p-cursor" id="board_marquee_title"><i class="fas fa-bullhorn mr-1"></i>即時訊息</div>'+
					'<div id="board_marquee_container">' +
		    			'<div id="board_marquee" class="marquee">資料連結中</div>'+
					'</div>' +
		    	'</div>'+
	    	'</div>'+
	    	boardHtml +
    	'</div>'
    );
	if (!isMobile) {
		$("#board_list .row").sortable({
			items:'.move_element'
		})
	}
}
function board_info_initial(project_id_query){
    $.ajax({
    	dataType: "json",
		url: publicPath + "/napi/obs/ncdrcapnew",
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		}
    }).done(function(cap_description_data){
	    var cap_html_string = "", link_signal = "", cap_li_list = ""
	    cap_description_data.forEach(function(element, index){
	    	if (index == cap_description_data.length-1) {
	    		link_signal = "<<資料來源：國家災害防救科技中心>>";
	    	}
			cap_html_string += (index+1)+ "." + element.capCodeName + "：" + element.description + link_signal + "　";
			cap_li_list += '<li>' + element.capCodeName + "：" + element.description + '<br/>'
				+ '生效時間：' + element.effective.replace('T', ' ') + '<br/>'
				+ '到期時間：' + element.expires.replace('T', ' ') + '<br/>' + link_signal + '</li>';
	    });
		$("#board_marquee").html(cap_html_string)
		$("#board_marquee_title").unbind().click(function(){
			modal_open('<ol>' + cap_li_list + '</ol>', `
				<span>新北市CAP示警資訊<span>
				<a target="_blank" href="https://alerts.ncdr.nat.gov.tw/">(資料來源：國家災害防救科技中心)</a>
				<span style="float:right">聯絡人：助理研究員 郭小姐、連絡電話：8195-8600</span>`)
		})
		marquee_adjust_position()
	})
	if (project_id_query) {
		refuge_board_info(project_id_query);
		death_board_info(project_id_query);
	}
	infrastructure_board_info();
	debris_board_info();
	pump_board_info();
	moving_pump_board_info();
	stage_wrap_board_info();
	stage_wrs_board_info();
	reservior_info();
	diviflow_info();
	waterdoor_board_info();
	flood_board_info();
	rain_board_info();
	banned_board_info();
	roadbreak_board_info();
	flood_sensor_board_info()
	underpass_water_board_info()
	// ntu2d_list_info();
	// cctv_status_info();
}
function board_auto_fit(){
	var logical = $(".panel").width();
	var window_width = $(window).width();
	if (logical == window_width) {
		$("#board_fold").click();
	}
}
function board_trig_unbing(Object_id){
	$(Object_id).siblings("span").find("i").eq(0).unbind();
	$(Object_id).siblings("span").find("i").eq(1).unbind();
}

// 資料來源提示框
const data_source = {
	"heart-broken": { name: '傷亡失蹤', unit: 'EMIS(消防局整備科)', contact: '許先生', phone: '89519119轉1883' },
    "phone-call": { name: '案件統計', unit: 'EMIS(消防局整備科)', contact: '許先生', phone: '89519119轉1883' },
    "open-home": { name: '疏散收容', unit: 'EMIS(消防局整備科)', contact: '許先生', phone: '89519119轉1883' },
    "rain": { name: '雨量站', unit: '氣象署', contact: '陳小姐', phone: '02-23497970' },
    "debris": { name: '土石流警戒', unit: '農村水保署', contact: '農業資料開放平台', phone: '(07)337-5153' },
    "flood_sensor": { name: '淹水感知器', unit: '水利署', contact: '水資源物聯網感測基礎雲端作業平台', phone: '' },
		"underpass": { name: '淹水感知器(車行地下道)', unit: '養工處', contact: '', phone: '' },
    "pump": { name: '抽水站', unit: '新北市水利局', contact: '陳先生', phone: '(02)29603456 分機5064' },
    "m_pumper": { name: '移動抽水機', unit: '抽管科', contact: '高先生', phone: '(02)22726610分機301' },
    "water_door": { name: '橫移門', unit: '新北市水利局', contact: '陳先生', phone: '(02)29603456 分機5064' },
    "water_stage": { name: '央管水位', unit: '水利署', contact: '施先生', phone: '02-37073072' },
    // "water_stage_local": { name: '市管水位', unit: '新北市水利局', contact: '陳先生', phone: '(02)29603456 分機5064' },
    "reservior": { name: '水庫洩洪', unit: '水利署', contact: '江先生', phone: '(02)37073055' },
    "outflow": { name: '員山子分洪道', unit: '十河分署', contact: '規劃科蕭先生', phone: '(02)89669870' },
    "flooding": { name: '淹水警戒', unit: '水利署', contact: '吳先生', phone: '02-37073128' },
    "flash": { name: '維生管線', unit: 'EMIC', contact: '許先生', phone: '89519119轉1883' },
}
var current_data_source = ''
function open_data_source(target) {
	$('#data_source_' + target).click(function(e){
		if (current_data_source == target) {
			$("#data_source_box").addClass('d-none')
			current_data_source = ''
			return
		}
		$("#data_source_box").html(`
			<div>
				${data_source[target].name}
				<i class="fas fa-times float-right"
					style="cursor: pointer"
					onclick="$('#data_source_box').addClass('d-none')">
				</i>
			</div>
			<div>資料來源：${data_source[target].unit}</div>
			<div>聯絡人：${data_source[target].contact}</div>
			<div>聯絡電話：${data_source[target].phone}</div>
		`).css({
			'position': 'absolute',
			'left': e.clientX + 10,
			'top': e.clientY,
			'z-index': '9999'
		}).removeClass('d-none')
		current_data_source = target
	})
}

// 即時訊息跑馬燈
function marquee_adjust_position(){
	setTimeout(function(){
		var width_board_container = $("#board_marquee_title").parent().width();
		var width_board_marquee_title = $("#board_marquee_title").width() + 8 + 3 + 7;
		var left_px = Math.round(width_board_marquee_title) + "px";
		var diff_width = (width_board_container - width_board_marquee_title) + "px";
		$("#board_marquee").css("left", left_px);
		$("#board_marquee").css("width", diff_width);
		var now_text = $("#board_marquee").text();
		$.keyframe.define([{
		    name: 'marquee',
		    '0%':   {"transform": "translateX(0)"},
		    '100%': {"transform": "translateX(-" + now_text.length + "em)"}
		}]);
		$("#board_marquee").css("animation", "marquee " + (now_text.length/6) + "s linear infinite");
	}, 1000)
}
// 傷亡失蹤(EMIS速報表)
function death_board_info(project_id_query){
	var url = publicPath + '/napi/emis/casualties?report_type=A1a&project_id=' + project_id_query;
	$.ajax({
		url: url,
		dataType: 'json',
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		}
	}).done(function(data) {
		var sum_death = 0, sum_lose = 0, sum_hurt = 0, sum_house = 0;
		var area_list = {'001': [], '002': [], '003': [], '004': [], '005': [], '009': [], '014': [], '016': [], '017': [], '018': [], '023': [], '024': [], '025': [], '027': [], '029': [], '033': [], '040': [], '041': [], '044': [], '045': [], '046': [], '048': [], '049': [], '050': [], '053': [], '054': [], '057': [], '061': [], '062': []};
		var area_list_sum = {'001': {}, '002': {}, '003': {}, '004': {}, '005': {}, '009': {}, '014': {}, '016': {}, '017': {}, '018': {}, '023': {}, '024': {}, '025': {}, '027': {}, '029': {}, '033': {}, '040': {}, '041': {}, '044': {}, '045': {}, '046': {}, '048': {}, '049': {}, '050': {}, '053': {}, '054': {}, '057': {}, '061': {}, '062': {}};
		board_trig_unbing("#board_heart-broken");
		if (data.length > 0) {
			data.forEach(function(element){
				area_list[element.AREA].push(element);
			})
			for(var key in area_list){
				area_list_sum[key]["sum_death"] = 0, area_list_sum[key]["sum_lose"] = 0, area_list_sum[key]["sum_hurt"] = 0, area_list_sum[key]["sum_house"] = 0;
				var length = area_list[key].length-1;
				for (var i = length; i <= length; i++) {
					sum_death += parseInt(area_list[key][i].PEOPLE_DEATH);
					sum_lose += parseInt(area_list[key][i].PEOPLE_LOSE);
					sum_hurt += parseInt(area_list[key][i].PEOPLE_HURT);
					sum_house += parseInt(area_list[key][i].HOUSE_LOSE);
					area_list_sum[key]["sum_death"] += parseInt(area_list[key][i].PEOPLE_DEATH);
					area_list_sum[key]["sum_lose"] += parseInt(area_list[key][i].PEOPLE_LOSE);
					area_list_sum[key]["sum_hurt"] += parseInt(area_list[key][i].PEOPLE_HURT);
					area_list_sum[key]["sum_house"] += parseInt(area_list[key][i].HOUSE_LOSE);
				}
			}
			$("#board_heart-broken, #live_broadcast_heart-broken").html("<ct class='r_text'>死亡" + sum_death + "人、" + "失蹤" + sum_lose + "人</ct>、" + "受傷" + sum_hurt + "人、房屋損毀" + sum_house + "棟");
		} else {
			$("#board_heart-broken").html("目前沒有速報資料");
		}
		open_data_source('heart-broken')
	    $("#board_heart-broken").siblings("span").find("i").eq(1).click(function(){
	    	var thead_string = '', tbody_string = '', tfoot_string = '';
		    thead_string = '<th>行政區名</th>' +
		    			   '<th>目前速報數</th>' +
		                   '<th>死亡</th>' +
		                   '<th>失蹤</th>' +
		                   '<th>受傷</th>' +
		                   '<th>房屋損毀</th>';
		    for(var key in area_list){
		    	// var length = area_list[key].length-1;
				tbody_string += '<tr>' +
					'<td>' + condition_area(key) + '</td>' +
					'<td>' + parseInt(area_list[key][length].RPT_NUM) + '</td>' +
					'<td class="r_text">' + parseInt(area_list_sum[key]["sum_death"]) + '</td>' +
					'<td class="r_text">' + parseInt(area_list_sum[key]["sum_lose"]) + '</td>' +
					'<td>' + parseInt(area_list_sum[key]["sum_hurt"]) + '</td>' +
					'<td>' + parseInt(area_list_sum[key]["sum_house"]) + '</td>' +
				'</tr>';
	        }
			tfoot_string = '<tr>' +
				'<td>總計</td>' +
				'<td> - </td>' +
				'<td class="r_text">' + sum_death + '</td>' +
				'<td class="r_text">' + sum_lose + '</td>' +
				'<td>' + sum_hurt + '</td>' +
				'<td>' + sum_house + '</td>' +
			'</tr>';
	        modal_open_table("各行政區死亡、失蹤與傷亡累計快速一覽表", thead_string, tbody_string, 2, tfoot_string);
	    })
	    $("#board_heart-broken").siblings("span").find("i").eq(1).click(function(){
	    	layer_remove();

	    	for(var key in area_list){
	    		var length = area_list[key].length-1;
		    	overlay_dataset["Basic_map"].features.forEach(function(element){
		    		if (element.properties.TOWNNAME == condition_area(key)) {
		    			var polygon = turf.polygon([element.geometry.coordinates[0]]);
		    			var centroid = turf.centroid(polygon);
		    			var coor = [centroid.geometry.coordinates[1], centroid.geometry.coordinates[0]];
				    	var death = parseInt(area_list[key][length].PEOPLE_DEATH), lose = parseInt(area_list[key][length].PEOPLE_LOSE), hurt = parseInt(area_list[key][length].PEOPLE_HURT);
				    	var popup_html = '<h5>' + condition_area(key) + '</h5>' + '<h5>死亡數：' + death + '</h5>' + '<h5>失蹤數：' + lose + '</h5>' + '<h5>受傷數：' + hurt + '</h5>';
				    	overlay_dataset["Basic_sta_map"] = L.minichart(coor, {data: [death, lose, hurt], labels: [hurt, lose, hurt], labelColor: "auto"})
				    		.bindPopup('<div id="other_area">' + popup_html + '</div>');
						map.addLayer(overlay_dataset["Basic_sta_map"]);
		    		};
		    	});
		    };
	    	board_auto_fit();
	    });
		if (sum_death > 0 || sum_lose > 0) {
			$("#board_component_heart-broken").addClass("hightlight")
		} else {
			$("#board_component_heart-broken").removeClass("hightlight")
		}
  	});
};
// 案件統計(EMIS速報表) ---> event_sta.js

// 疏散收容(EMIS速報表)
function refuge_board_info(project_id_query){
	var url = publicPath + '/napi/emis/evacuation?report_type=A4a&project_id=' + project_id_query;
	var data = ajax_call(url);
	var url_refuge = publicPath + '/napi/emis/shelter_condition?report_type=D3a&project_id=' + project_id_query;
	var data_refuge = ajax_call(url_refuge);
	var sum_withdraw = 0, now_accept = 0, sum_accept = 0;
	var area_list = {'001': [], '002': [], '003': [], '004': [], '005': [], '009': [], '014': [], '016': [], '017': [], '018': [], '023': [], '024': [], '025': [], '027': [], '029': [], '033': [], '040': [], '041': [], '044': [], '045': [], '046': [], '048': [], '049': [], '050': [], '053': [], '054': [], '057': [], '061': [], '062': []};
	var area_refuge_list = {'001': [], '002': [], '003': [], '004': [], '005': [], '009': [], '014': [], '016': [], '017': [], '018': [], '023': [], '024': [], '025': [], '027': [], '029': [], '033': [], '040': [], '041': [], '044': [], '045': [], '046': [], '048': [], '049': [], '050': [], '053': [], '054': [], '057': [], '061': [], '062': []};
	board_trig_unbing("#board_open-home");
	open_data_source('open-home')
	if (data.length > 0) {
		// 避難
		data.forEach(function(element){
			area_list[element.AREA].push(element);
		})
		for(var key in area_list){
			var length = area_list[key].length-1;
			if (length >= 0) {
				var rpt_number_this = area_list[key][length].RPT_NUM;
				area_list[key].forEach(function(element){
					if (element.RPT_NUM == rpt_number_this) {
						sum_withdraw += parseInt(element.WITHDRAW_SUM);
					}
				})
			}
		}
		// 收容
		data_refuge.forEach(function(element){
			area_refuge_list[element.AREA].push(element);
		})
		for(var key in area_refuge_list){
			var length = area_refuge_list[key].length-1;
			if (length >= 0) {
				var rpt_number_this = area_refuge_list[key][length].RPT_NUM;
				area_refuge_list[key].forEach(function(element){
					if (element.RPT_NUM == rpt_number_this) {
						now_accept += parseInt(element.ACCEPT_PEOPLE);
						sum_accept += parseInt(element.ACCEPT_PEOPLE_SUM);
					}
				})
			}
		}
		$("#board_open-home, #live_broadcast_open-home").html('<ct class="r_text">累計撤離' + sum_withdraw + "人</ct>、累計收容" + sum_accept + "人、目前收容" + now_accept + "人");
	} else {
		$("#board_open-home, #live_broadcast_open-home").html("目前沒有速報資料");
	}
	if (sum_withdraw > 0) $("#board_component_open-home").addClass("hightlight")
	else $("#board_component_open-home").removeClass("hightlight")

	$("#board_open-home").siblings("span").find("i").eq(1).click(function(){
		var thead_string = '', tbody_string = '', tfoot_string = '';
		thead_string = '<th>行政區名</th>' +
					   '<th>撤離人數</th>' +
					   '<th>累積收容人數</th>' +
					   '<th>目前收容人數</th>'
		for(var key in area_list){
			// var length = area_list[key].length-1;
			tbody_string += '<tr>' +
				'<td>' + condition_area(key) + '</td>' +
				'<td>' + area_list[key].map(el => el.WITHDRAW_SUM).reduce((acc, cur) => acc + cur, 0) + '</td>' +
				'<td>' + area_refuge_list[key].map(el => el.length > 0 ? el[0]['ACCEPT_PEOPLE_SUM'] : 0)
					.reduce((acc, cur) => acc + cur, 0) + '</td>' +
					'<td>' + area_refuge_list[key].map(el => el.length > 0 ? el[0]['ACCEPT_PEOPLE'] : 0)
					.reduce((acc, cur) => acc + cur, 0) + '</td>' +
			'</tr>';
		}
		tfoot_string = '<tr>' +
			'<td>總計</td>' +
			'<td>' + sum_withdraw + '</td>' +
			'<td>' + sum_accept + '</td>' +
			'<td>' + now_accept + '</td>' +
		'</tr>';
		modal_open_table("各行政區撤離、累計收容與目前收容快速一覽表", thead_string, tbody_string, 2, tfoot_string);
	})
}

// 顯示淹水相關圖層
function showFloodLayer(isHeavyRain){
	if (isHeavyRain) {
		console.log(`isHeavyRain=${isHeavyRain}, showFloodLayer`)
		const floodLayerIds = [
			"NCDR歷史淹水點位(109~113年)",
			"NCDR歷史淹水範圍(109~113年)",
			"易淹水通報點位",
			"歷史淹水熱度圖",
			"歷史淹水範圍",
			"淹水易致災村里"
		];
		floodLayerIds.forEach(layerId => {
			const layerElement = document.getElementById(layerId);
			if (layerElement && !layerElement.checked) {
				layerElement.click();
			}
		});
	}
}

// 雨量站(氣象局)
function rain_board_info(){
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/obs/rainobs",
		dataType: 'json',
		success: function (data) {
            raw_data["雨量站"] = data;
        }
	}).done(function(data) {
		var rain_container = {}, string = '', thead_string = '', tbody_string = '', sum = {level_1: 0, level_2: 0, level_3: 0, level_4: 0, level_0: 0, none: 0};
		data.forEach(function(element){
			if (element.CITY == "新北市") {
				if (rain_container[element.STID] != undefined) {
					var the_same_sta_time_lag_diff = time_sql_processing(rain_container[element.STID].TIME) - time_sql_processing(element.TIME);
					if (the_same_sta_time_lag_diff < 0) {
						rain_container[element.STID] = element;
					}
				}
				rain_container[element.STID] = element;
			}
		});

		for(var element_key in rain_container){
			if (rain_container[element_key].status_value == -1) sum["none"]++;
			else sum["level_" + rain_container[element_key].status_value]++
			tbody_string +=
				'<tr>' +
                    '<td>' + rain_container[element_key].TOWN + '</td>' +
                    '<td>' + rain_container[element_key].TIME.slice(0,16) + '</td>' +
                    '<td>' + (rain_container[element_key].STID + rain_container[element_key].STNM) + '</td>' +
                    '<td>' + rain_value_processing(rain_container[element_key].MIN_10) + '</td>' +
                    '<td>' + rain_value_processing(rain_container[element_key].RAIN) + '</td>' +
                    '<td>' + rain_value_processing(rain_container[element_key].HOUR_3) + '</td>' +
                    '<td>' + rain_value_processing(rain_container[element_key].HOUR_6) + '</td>' +
                    '<td>' + rain_value_processing(rain_container[element_key].HOUR_12) + '</td>' +
                    '<td>' + rain_value_processing(rain_container[element_key].HOUR_24) + '</td>' +
                '</tr>';
		}

		// 檢查 sum [level_1, level_2, level_3, level_4] 是否有任一項 大於0
		if (sum["level_1"] > 0 || sum["level_2"] > 0 || sum["level_3"] > 0 || sum["level_4"] > 0) {
			showFloodLayer(true);
		}

		$("#board_rain, #live_broadcast_rain").html(`
			<ct class="r_text" id="board_rain_level_4">超大豪雨${sum["level_4"]}處</ct>、
			<ct class="r_text" id="board_rain_level_3">大豪雨${sum["level_3"]}處</ct>、
			<ct class="r_text" id="board_rain_level_2">豪雨${sum["level_2"]}處</ct>、
			<ct class="y_text" id="board_rain_level_1">大雨${sum["level_1"]}處</ct>、
			<ct id="board_rain_level_0">未達警戒${sum["level_0"]}處</ct>、
			<ct class="gray_text" id="board_rain_offline">離線${sum["none"]}處</ct>
		`)

		$("#board_rain_level_1, #board_rain_level_2, #board_rain_level_3, #board_rain_level_4, #board_rain_level_0, #board_rain_offline").click((e) => {
			layer_remove();
			let status = ''
			switch (e.target.id) {
				case 'board_rain_level_4':
					status = '超大豪雨'
					break
				case 'board_rain_level_3':
					status = '大豪雨'
					break
				case 'board_rain_level_2':
					status = '豪雨'
					break
				case 'board_rain_level_1':
					status = '大雨'
					break
				case 'board_rain_level_0':
					status = '正常'
					break
				case 'board_rain_offline':
					status = '離線'
					break
			}
			let result = rain_cwb(status)
			overlay_dataset['filteredLayer'] = result[0]
			map.addLayer(overlay_dataset['filteredLayer'])
		})

	    $("#scenario_content_rain").html('<ct class="r_text">超大豪雨' + sum["level_4"] + '處</ct>、<ct class="r_text">大豪雨' + sum["level_3"] + '處</ct>、<ct class="r_text">豪雨' + sum["level_2"] + '處</ct>、<ct class="y_text">大雨' + sum["level_1"] + "處</ct>");

		thead_string =
			'<th>行政區</th>' +
			'<th>時間</th>' +
			'<th>站號</th>' +
			'<th>10分鐘雨量</th>' +
			'<th>時雨量</th>' +
			'<th>近3時雨量</th>' +
			'<th>近6時雨量</th>' +
			'<th>近12時雨量</th>' +
			'<th>近24時雨量</th>';
	    board_trig_unbing("#board_rain");
		open_data_source('rain')
	    $("#board_rain").siblings("span").find("i").eq(1).click(function(){
	    	modal_open_table("雨量站快速一覽表", thead_string, tbody_string, 1);
	    });
	    $("#board_rain").siblings("span").find("i").eq(2).click(function(){
	    	layer_remove();
	    	backgroud_layer_control("雨量站");
	    	board_auto_fit();
	    });
		if (sum["level_1"] > 0 || sum["level_2"] > 0 || sum["level_3"] > 0 || sum["level_4"] > 0) {
			$("#board_component_rain").addClass("hightlight")
		} else {
			$("#board_component_rain").removeClass("hightlight")
		}
	});
};
// 土石流警戒(水保署)
function debris_board_info(){
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/obs/debrisalert",
		dataType: 'json',
		timeout: 5000,
		success: function (data) {
            raw_data["土石流潛勢溪流"] = data;
			var data_NTC = [];
			var yellow_number = 0, red_number = 0, thead_string = '', tbody_string = '', status = "";
			var no_alert = `
				<ct class="r_text" id="debris_red_alert">紅色警戒0條</ct>、
				<ct class="y_text" id='debris_yellow_alert'>黃色警戒0條</ct>
				(本市共237條)`
			if (data == null) {
				$("#board_debris, #live_broadcast_debris").html(no_alert);
				$("#scenario_content_debris").html('<ct class="r_text">紅色警戒' + red_number + '條</ct>、<ct class="y_text">黃色警戒' + yellow_number + "條</ct>(本市共237條)");
			} else{
				if (data.errorMessage != undefined) {
					$("#board_debris, #live_broadcast_debris").html(no_alert);
					$("#scenario_content_debris").html('<ct class="r_text">紅色警戒' + red_number + '條</ct>、<ct class="y_text">黃色警戒' + yellow_number + "條</ct>(本市共237條)");
				} else if (data.status == "fail") {
					$("#board_debris, #live_broadcast_debris").html("來源介接異常");
					$("#scenario_content_debris").html("來源介接異常");
				} else {
					data.forEach(function(element){
						if (element.county == "新北市") {
							data_NTC.push(element)
						}
					});
					if (data_NTC.length != 0) {
						data_NTC.forEach(function(element){
							if (element.alert_date_yellow != "") {
								yellow_number += 1;
								tbody_string += '<tr>' +
			                        '<td>' + element.town + '</td>' +
			                        '<td>' + element.vill + '</td>' +
			                        '<td>' + element.debrisNo + '</td>' +
			                        '<td class="y_text">黃色</td>' +
			                        '<td>' + element.alert_date_yellow + '</td>' +
			                    '</tr>';
							}
							if (element.alert_date != "") {
								red_number += 1;
								tbody_string += '<tr>' +
			                        '<td>' + element.town + '</td>' +
			                        '<td>' + element.vill + '</td>' +
			                        '<td>' + element.debrisNo + '</td>' +
			                        '<td class="r_text">紅色</td>' +
			                        '<td>' + element.alert_date + '</td>' +
			                    '</tr>';
							}
						});
						$("#board_debris, #live_broadcast_debris").html(`
							<ct class="r_text" id="debris_red_alert">紅色警戒${red_number}條</ct>、
							<ct class="y_text" id='debris_yellow_alert'>黃色警戒${yellow_number}條</ct>
						(本市共237條)`)
						$("#scenario_content_debris").html('<ct class="r_text">紅色警戒' + red_number + '條</ct>、<ct class="y_text">黃色警戒' + yellow_number + "條</ct>(本市共237條)");
					} else {
						$("#board_debris, #live_broadcast_debris").html(no_alert);
						$("#scenario_content_debris").html('<ct class="r_text">紅色警戒' + red_number + '條</ct>、<ct class="y_text">黃色警戒' + yellow_number + "條</ct>(本市共237條)");
					};
				}
			}

			$("#debris_red_alert").click(() => {
				layer_remove();
				let result = debris_flow_swcb('紅色')
				overlay_dataset['filteredLayer'] = result[0]
				map.addLayer(overlay_dataset['filteredLayer'])
			})
			$("#debris_yellow_alert").click(() => {
				layer_remove();
				let result = debris_flow_swcb('黃色')
				overlay_dataset['filteredLayer'] = result[0]
				map.addLayer(overlay_dataset['filteredLayer'])
			})

		    thead_string = '<th>行政區</th>' +
		    			   '<th>村里名</th>' +
		                   '<th>潛勢溪流編號</th>' +
		                   '<th>等級</th>'+
		                   '<th>發布時間</th>';
		    board_trig_unbing("#board_debris");
			open_data_source('debris')
		    $("#board_debris").siblings("span").find("i").eq(1).click(function(){
		    	modal_open_table("土石流潛勢溪流警戒快速一覽表", thead_string, tbody_string, 3);
		    });
		    $("#board_debris").siblings("span").find("i").eq(2).click(function(){
		    	layer_remove();

		    	backgroud_layer_control("土石流潛勢溪流");
		    	board_auto_fit();
		    })
			if (yellow_number > 0 || red_number > 0) {
				$("#board_component_debris").addClass("hightlight")
			} else {
				$("#board_component_debris").removeClass("hightlight")
			}
        }
	})
	.fail(function(jqXHR, textStatus, errorThrown){
		$("#board_debris").html("介接發生問題！");
	});
}
// 淹水感知器(水利署)
function flood_sensor_board_info(){
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/flood/get_flood_sensor_list_obs/all",
		dataType: 'json',
		success: function (dataStation) {
			let geoJson = turf.featureCollection([])
			if (dataStation) {
				geoJson = create_flood_sensor_geojson(dataStation.data)
			}
			raw_data["淹水感知器"] = geoJson
        }
	}).done(function(data) {
		try {
			var tbody_string = "",
				sum = {
					"離線": 0,
					"淹水": 0,
					"積水": 0,
					"未達": 0
				}
			raw_data["淹水感知器"].features.forEach(feature => {
				let statusHTML = ''
				if (feature.properties.status == '淹水') {
					statusHTML = `<span class="r_text">${feature.properties.status}</span>`
				} else if (feature.properties.status == '積水') {
					statusHTML = `<span class="y_text">${feature.properties.status}</span>`
				} else statusHTML = `<span>${feature.properties.status}</span>`
				tbody_string += `
					<tr>
						<td>${feature.properties.townname}</td>
						<td>${feature.properties.villname}</td>
						<td>${feature.properties.st_name}</td>
						<td>${feature.properties.time}</td>
						<td>${feature.properties.level}cm</td>
						<td>${statusHTML}</td>
					</tr>`
				sum[feature.properties.status] += 1
			})
			$("#board_flood_sensor, #live_broadcast_flood_sensor").html(`
				<ct class="r_text" id="board_flood_sensor_flood">淹水${sum["淹水"]}處</ct>、
				<ct class="y_text" id="board_flood_sensor_puddle">積水${sum["積水"]}處</ct>、
				<ct id="board_flood_sensor_no_alert">未達警戒${sum["未達"]}處</ct>、
				<ct class="gray_text" id="board_flood_sensor_offline">離線${sum["離線"]}處</ct>
			`)

			$("#board_flood_sensor_flood, #board_flood_sensor_puddle, #board_flood_sensor_no_alert, #board_flood_sensor_offline").click((e) => {
				layer_remove();
				let status = ''
				switch (e.target.id) {
					case 'board_flood_sensor_flood':
						status = '淹水'
						break
					case 'board_flood_sensor_puddle':
						status = '積水'
						break
					case 'board_flood_sensor_no_alert':
						status = '未達'
						break
					case 'board_flood_sensor_offline':
						status = '離線'
						break
				}
				let result = layer_flood_sensor(status)
				overlay_dataset['filteredLayer'] = result[0]
				map.addLayer(overlay_dataset['filteredLayer'])
			})

			$("#scenario_content_flood").html(`<ct class="r_text">淹水${sum["淹水"]}處</ct>、<ct class="y_text">積水${sum["積水"]}處</ct>`)
			board_trig_unbing("#board_flood_sensor");
			open_data_source('flood_sensor')
			$("#board_flood_sensor").siblings("span").find("i").eq(1).click(function(){
				modal_open_table(
					"淹水感知器測站快速一覽表",
					"<th>行政區</th><th>村里</th><th>測站名</th><th>觀測時間</th><th>觀測水位</th><th>狀態</th>",
					tbody_string,
					0
				)
			})
			$("#board_flood_sensor").siblings("span").find("i").eq(2).click(function(){
				layer_remove()
				backgroud_layer_control("淹水感知器")
				board_auto_fit()
			})
			if (sum["淹水"] > 0 || sum["積水"] > 0) {
				$("#board_component_flood_sensor").addClass("hightlight")
			} else {
				$("#board_component_flood_sensor").removeClass("hightlight")
			}
		} catch (e) {
			$("#board_flood_sensor").html("介接資料異常！");
		}
	})
}
// 抽水站(水利局)
function pump_board_info(){
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/obs/pumpstatus",
		dataType: 'json',
		success: function (data) {
            raw_data["抽水站"] = data;
        }
	}).done(function(data){
		var sum = {open: 0, standby: 0, none: 0 }, thead_string = '', tbody_string = '';
		data.forEach(function(element){
			var time_lag = get_now_time_UTC() - time_sql_processing(element.time),
				status = pump_status_true(element.status),
				statusHTML = ''
			if (time_lag > 3600000 * 2) {
				sum["none"] = sum["none"] + 1;
			} else {
				if (status == "開啟") {
					sum["open"] = sum["open"] + 1;
					statusHTML = `<span class="r_text">${status}</span>`
				} else {
					sum["standby"] = sum["standby"] + 1;
					statusHTML = `<span>${status}</span>`
				}
			};
			tbody_string +=
				'<tr>' +
					'<td>' + element.address_zh + '</td>' +
					'<td>' + element.name_zh + '(' + element.station_no + ')</td>' +
					'<td>' + element.time.slice(0,16) + '</td>' +
					'<td>' + statusHTML + '</td>' +
				'</tr>'
		})
		$("#board_pump, #live_broadcast_pump").html(`
			<ct class="r_text" id="board_pump_open">運轉中${sum["open"]}處</ct>、
			<ct id="board_pump_standby">待命中${sum["standby"]}處</ct>、
			<ct class="gray_text" id="board_pump_none">離線${sum["none"]}處</ct>
		`);

		$("#board_pump_open, #board_pump_standby, #board_pump_none").click((e) => {
			layer_remove();
			let status = ''
			switch (e.target.id) {
				case 'board_pump_open':
					status = '運轉中'
					break
				case 'board_pump_standby':
					status = '待命中'
					break
				case 'board_pump_none':
					status = '離線'
					break
			}
			let result = pump_wrs(status)
			overlay_dataset['filteredLayer'] = result[0]
			map.addLayer(overlay_dataset['filteredLayer'])
		})

		$("#scenario_content_pump_station").html('<ct class="r_text">運轉' + sum["open"] + '處</ct>、待命' + sum["standby"] + '處' + '、<ct class="gray_text">離線' + sum["none"]  + '處(抽水站)</ct>')
		$("#scenario_content_pump_station").html(`
			<ct class="r_text">運轉${sum["open"]}處</ct>、
			待命${sum["standby"]}處、
			<ct class="gray_text">離線${sum["none"]}處(抽水站)</ct>
		`);
	    thead_string = '<th>地址</th><th>站名</th><th>時間</th><th>抽水狀態</th>';
	    board_trig_unbing("#board_pump");
		open_data_source('pump')
	    $("#board_pump").siblings("span").find("i").eq(1).click(function(){
	    	modal_open_table("抽水站運作快速一覽表", thead_string, tbody_string, 2);
	    })
	    $("#board_pump").siblings("span").find("i").eq(2).click(function(){
	    	layer_remove();
	    	backgroud_layer_control("抽水站");
	    	board_auto_fit();
	    })
		if (sum["open"] > 0) {
			$("#board_component_pump").addClass("hightlight")
		} else {
			$("#board_component_pump").removeClass("hightlight")
		}
  	});
}
function pump_status_true(string){
	var string_raw, logical_statement;
    string_raw = string.split("|");
	string_raw.forEach(function(element){
		if (element == "1") {
			logical_statement = "開啟";
		}
	});
	if (logical_statement == undefined) {
		logical_statement = "停止";
	}
	return logical_statement;
}
// 移動抽水機(水利局)
function moving_pump_board_info(){
	var sum_1 = 0, sum_2 = 0, sum_3 = 0, sum_4 = 0, sum_5 = 0, sum_6 = 0, thead_string = '', tbody_string = '';
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/obs/pumpmoving",
		dataType: 'json',
		// timeout: 5000,
		success: function (res) {
			let car_data = res
            raw_data["移動抽水機"] = car_data;
			board_trig_unbing("#board_m_pumper");
			if (car_data) {
				car_data.forEach(function(element){
					let statusHTML = `<span>${element._status}</span>`
					switch(element._status){
						case "抽水中":
							sum_1 = sum_1 + 1;
							statusHTML = `<span class="r_text">${element._status}</span>`
							break;
						case "待命":
							sum_2 = sum_2 + 1;
							break;
						case "運送中":
							sum_3 = sum_3 + 1;
							break;
						case "離線":
							sum_4 = sum_4 + 1;
							break;
						case "故障":
							sum_5 = sum_5 + 1;
							break;
						default:
							sum_6 = sum_6 + 1;
					};
					tbody_string +=
						'<tr>' +
	                        '<td>' + element._id + '</td>' +
	                        '<td>' + element.operateat.slice(0,16) + '</td>' +
	                        '<td>' + statusHTML + '</td>' +
	                        '<td>' + element._road + '</td>' +
	                    '</tr>';
				});
				$("#board_m_pumper, #live_broadcast_m_pumper").html(`
					<ct class="r_text" id="board_m_pumper_open">抽水${sum_1}處</ct>、
					<ct id="board_m_pumper_standby">待命${sum_2}處</ct>、
					<ct id="board_m_pumper_transport">運送${sum_3}處</ct>、
					<ct class="gray_text" id="board_m_pumper_offline">離線${sum_4}處</ct>、
					<ct class="gray_text" id="board_m_pumper_fault">故障${sum_5}處</ct>、
					<ct class="gray_text" id="board_m_pumper_other">其它${sum_6}處</ct>
				`);

				$("#board_m_pumper_open, #board_m_pumper_standby, #board_m_pumper_transport, #board_m_pumper_offline, #board_m_pumper_fault, #board_m_pumper_other").click((e) => {
					layer_remove();
					let status = ''
					switch (e.target.id) {
						case 'board_m_pumper_open':
							status = '抽水中'
							break
						case 'board_m_pumper_standby':
							status = '待命'
							break
						case 'board_m_pumper_transport':
							status = '運送中'
							break
						case 'bboard_m_pumper_offline':
							status = '離線'
							break
						case 'board_m_pumper_fault':
							status = '故障'
							break
						case 'board_m_pumper_other':
							status = '其他'
							break
					}
					let result = moving_car_wrs(status)
					overlay_dataset['filteredLayer'] = result[0]
					map.addLayer(overlay_dataset['filteredLayer'])
				})

			    $("#scenario_content_pump_moving").html('<ct class="r_text">抽水' + sum_1 + '處</ct>、待命' + sum_2 + "處" + "、運送" + sum_3 + "處、故障" + sum_5 + "處(移抽)");
				thead_string =
					'<th>機具編號</th>' +
					'<th>時間</th>' +
					'<th>狀態</th>' +
					'<th>所在道路</th>';
				open_data_source('m_pumper')
			    $("#board_m_pumper").siblings("span").find("i").eq(1).click(function(){
			    	modal_open_table("移動式抽水機快速一覽表", thead_string, tbody_string, 1);
			    });
			    $("#board_m_pumper").siblings("span").find("i").eq(2).click(function(){
			    	layer_remove();

			    	backgroud_layer_control("移動抽水機");
			    	board_auto_fit();
			    });
				if (sum_1 > 0) {
					$("#board_component_m_pumper").addClass("hightlight")
				} else {
					$("#board_component_m_pumper").removeClass("hightlight")
				}
			} else{
				raw_data["移動抽水機"] = ajax_call("../defalut_data/temp_m_pumper.json")
				$("#board_m_pumper").html("介接發生問題！");
			};
        }
	})
	.fail(function(jqXHR, textStatus, errorThrown){
		raw_data["移動抽水機"] = ajax_call("../defalut_data/temp_m_pumper.json")
		$("#board_m_pumper").html("介接發生問題！");
	});
}
// 橫移門(水利局)
function waterdoor_board_info(){
	var number_open = 0, number_close = 0, number_none = 0, data_basic_object = {};
	var data_basic = raw_data["wrs_gate_basic"];
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/obs/othergate",
		dataType: 'json',
		success: function (data) {
            raw_data["橫移門"] = data;
        }
	}).done(function(data) {
		data_basic.forEach(function(element){
			data_basic_object[element.Gate_No] = {
				"NAME_C" : element.NAME_C,
				"Gate_No" : element.Gate_No,
				"ADDR_C" : element.ADDR_C
			}
		});
		var name, number_gate, address, status, time_lag, tbody_string = '';
		data.forEach(function(element){
			if (element.Gate_No.slice(0,1) == "G") {
				name = data_basic_object[element.Gate_No].NAME_C;
				number_gate = data_basic_object[element.Gate_No].Gate_No;
				address = data_basic_object[element.Gate_No].ADDR_C;
				time_lag = get_now_time_UTC() - time_sql_processing(element.Date);
				if (time_lag > 3600000 * 2) {
					number_none = number_none + 1;
					status = "離線";
				} else {
					if (element.Gate_No == "G15") {
						var string_raw = element.OpenClose.split("|");
						if (string_raw[0] == "0" && string_raw[1] == "0") {
							number_close += 1;
							status = "關閉";
						} else{
							number_open += 1;
							status = "開啟";
						}
					} else {
						switch(element.OpenClose){
							case "1":
								number_open += 1;
								status = "開啟";
								break;
							case "0":
								number_close += 1;
								status = "關閉";
								break;
						}
					}
				};
				let statusHTML = status == '關閉' ? `<span class="r_text">${status}</span>` : `<span>${status}</span>`
				tbody_string +=
					'<tr>' +
						'<td>' + name + "(" + element.Gate_No + ")" + '</td>' +
						'<td>' + element.Date.slice(0,16) + '</td>' +
						'<td>' + address + '</td>' +
						'<td>' + statusHTML + '</td>' +
					'</tr>';
			}
		});
	    var thead_string = '<th>橫移門名稱</th>' + '<th>時間</th>' + '<th>地址</th>' + '<th>狀態</th>';
		$("#board_water_door, #live_broadcast_water_door").html(`
			<ct id="board_water_door_open">開啟${number_open}處</ct>、
			<ct class="r_text" id="board_water_door_closed">關閉${number_close}處</ct>、
			<ct class="gray_text" id="board_water_door_offline">離線${number_none}處</ct>
		`)

		$("#board_water_door_open, #board_water_door_closed, #board_water_door_offline").click((e) => {
			layer_remove();
			let status = ''
			switch (e.target.id) {
				case 'board_water_door_open':
					status = '開啟'
					break
				case 'board_water_door_closed':
					status = '關閉'
					break
				case 'board_water_door_offline':
					status = '離線'
					break
			}
			let result = waterdoor_status(status)
			overlay_dataset['filteredLayer'] = result[0]
			map.addLayer(overlay_dataset['filteredLayer'])
		})

		if (number_close > 0) $("#board_component_water_door").addClass("hightlight")

		board_trig_unbing("#board_water_door");
		open_data_source('water_door')
	    $("#board_water_door").siblings("span").find("i").eq(1).click(function(){
	    	modal_open_table("橫移門快速一覽表", thead_string, tbody_string, 3);
	    })
	    $("#board_water_door").siblings("span").find("i").eq(2).click(function(){
	    	layer_remove();
	    	backgroud_layer_control("橫移門");
	    	board_auto_fit();
	    })
	});
}
// 央管水位(水利署)
function stage_wrap_board_info(){
	var sum_first = 0, sum_second = 0, sum_third = 0, sum_normal = 0, sum_no_data = 0, total = 0, thead_string = '', tbody_string = '';
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/obs/wrawaterlevel",
		dataType: 'json',
		success: function (data) {
            raw_data["水利署水位"] = data;
        }
	}).done(function(data) {
		data.forEach(function(element){
			var time_lag = get_now_time_UTC() - time_sql_processing(element.time);
			let waterlevel = null_Converter_v2(parseFloat(element.water_level).toFixed(2))
			let waterlevelHTML = `<span>${waterlevel}</span>`
			if (time_lag > 3600000 * 2) {
				sum_no_data = sum_no_data + 1;
			} else {
				total = total + 1;
				switch(true){
					case(element.water_level >= element.alert_level_3 && element.water_level < element.alert_level_2 && element.alert_level_2 != null && element.alert_level_3 != null):
						sum_third = sum_third + 1;
						waterlevelHTML = `<span class="y_text">${waterlevel}</span>`
						break;
					case(element.water_level >= element.alert_level_2 && element.water_level < element.alert_level_1 && element.alert_level_2 != null && element.alert_level_1 != null):
						sum_second = sum_second + 1;
						waterlevelHTML = `<span class="p_text">${waterlevel}</span>`
						break;
					case(element.water_level >= element.alert_level_1 && element.alert_level_1 != null):
						sum_first = sum_first + 1;
						waterlevelHTML = `<span class="r_text">${waterlevel}</span>`
						break;
					default:
						sum_normal = sum_normal + 1;
						waterlevelHTML = `<span class="gray_text">${waterlevel}</span>`
				}
			}
			tbody_string +=
				'<tr>' +
					'<td>' + element.location_address + '</td>' +
					'<td>' + element.observatory_name + '</td>' +
					'<td>' + element.station_identifier + '</td>' +
					'<td>' + element.time.slice(0,16) + '</td>' +
					'<td>' + waterlevelHTML + '</td>' +
					'<td>' + null_Converter_v2(element.alert_level_1) + '</td>' +
					'<td>' + null_Converter_v2(element.alert_level_2) + '</td>' +
					'<td>' + null_Converter_v2(element.alert_level_3) + '</td>' +
				'</tr>';
		});
		$("#board_water_stage, #live_broadcast_water_stage").html(`
			<ct class="r_text" id="board_water_stage_alert1">一級${sum_first}處</ct>、
			<ct class="p_text" id="board_water_stage_alert2">二級${sum_second}處</ct>、
			<ct class="y_text" id="board_water_stage_alert3">三級${sum_third}處</ct>、
			<ct id="board_water_stage_no_alert">未達警戒${(sum_normal)}處</ct>、
			<ct class="gray_text" id="board_water_stage_offline">離線${sum_no_data}處</ct>
		`);

		$("#board_water_stage_alert1, #board_water_stage_alert2, #board_water_stage_alert3, #board_water_stage_no_alert, #board_water_stage_offline").click((e) => {
			layer_remove();
			let status = ''
			switch (e.target.id) {
				case 'board_water_stage_alert1':
					status = '一級'
					break
				case 'board_water_stage_alert2':
					status = '二級'
					break
				case 'board_water_stage_alert3':
					status = '三級'
					break
				case 'board_water_stage_no_alert1':
					status = '未達警戒'
					break
				case 'board_water_stage_offline':
					status = '離線'
					break
			}
			let result = stage_wra(status)
			overlay_dataset['filteredLayer'] = result[0]
			map.addLayer(overlay_dataset['filteredLayer'])
		})

	    thead_string =
			'<th>地址</th>' +
			'<th>站名</th>' +
			'<th>站號</th>' +
			'<th>時間</th>' +
			'<th>水位值</th>' +
			'<th>一級水位</th>'+
			'<th>二級水位</th>'+
			'<th>三級水位</th>';
	    board_trig_unbing("#board_water_stage");
		open_data_source('water_stage')
	    $("#board_water_stage").siblings("span").find("i").eq(1).click(function(){
	    	modal_open_table("央管水位快速一覽表", thead_string, tbody_string, 3);
	    })
	    $("#board_water_stage").siblings("span").find("i").eq(2).click(function(){
	    	layer_remove();
	    	backgroud_layer_control("水利署水位");
	    	board_auto_fit();
	    });
		if (sum_first > 0 || sum_second > 0 || sum_third > 0) {
			$("#board_component_stage").addClass("hightlight")
		} else {
			$("#board_component_stage").removeClass("hightlight")
		}
  	});
}
// 市管水位(水利局)
function stage_wrs_board_info(){
	var sum = {red: 0, green: 0, none: 0}, thead_string = '', tbody_string = ''
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/obs/wrswaterlevel",
		dataType: 'json',
		success: function (data) {
            raw_data["水利局水位"] = data
        }
	}).done(function(data) {
		data.forEach(function(element){
			var time_lag = get_now_time_UTC() - time_sql_processing(element.time);
			let waterlevel = parseFloat(element.waterl_evel).toFixed(2)
			let waterlevelHTML = `<span>${waterlevel}</span>`
			if (time_lag > 3600000 * 2) {
				sum["none"] = sum["none"] + 1
			} else {
				if (element.waterl_evel > element.alert_level_1) {
					sum["red"] = sum["red"] + 1
					waterlevelHTML = `<span class="r_text">${waterlevel}</span>`
				} else {
					sum["green"] = sum["green"] + 1
				}
			}
			tbody_string +=
				'<tr>' +
                    '<td>' + element.stn_name + '</td>' +
                    '<td>' + element.sensor_name + '</td>' +
                    '<td>' + element.time.slice(0,16) + '</td>' +
                    '<td>' + waterlevelHTML + '</td>' +
                    '<td>' + parseFloat(element.alert_level_1).toFixed(2) + '</td>' +
                '</tr>';
		});
		$("#board_water_stage_local, #live_broadcast_water_stage_local").html(`
			<ct class="r_text" id="board_water_stage_local_alert1">一級水位${sum["red"]}處</ct>、
			<ct id="board_water_stage_local_no_alert">未達警戒${sum["green"]}處</ct>、
			<ct class="gray_text" id="board_water_stage_local_offline">離線${sum["none"]}處</ct>
		`);

		$("#board_water_stage_local_alert1, #board_water_stage_local_no_alert, #board_water_stage_local_offline").click((e) => {
			layer_remove();
			let status = ''
			switch (e.target.id) {
				case 'board_water_stage_local_alert1':
					status = '一級'
					break
				case 'board_water_stage_local_no_alert':
					status = '未達警戒'
					break
				case 'board_water_stage_local_offline':
					status = '離線'
					break
			}
			let result = stage_wrs(status)
			overlay_dataset['filteredLayer'] = result[0]
			map.addLayer(overlay_dataset['filteredLayer'])
		})

	    thead_string = '<th>站名</th>' +
	                   '<th>站號</th>' +
	                   '<th>時間</th>' +
	                   '<th>水位值</th>' +
	                   '<th>一級水位</th>'
	    board_trig_unbing("#board_water_stage_local");
		open_data_source('water_stage_local')
	    $("#board_water_stage_local").siblings("span").find("i").eq(1).click(function(){
	    	modal_open_table("市管水位快速一覽表", thead_string, tbody_string, 2);
	    })
	    $("#board_water_stage_local").siblings("span").find("i").eq(2).click(function(){
	    	layer_remove();

	    	backgroud_layer_control("水利局水位");
	    	board_auto_fit();
	    })
		if (sum["red"] > 0) {
			$("#board_component_stage_local").addClass("hightlight")
		} else {
			$("#board_component_stage_local").removeClass("hightlight")
		}
  	});
}
// 水庫洩洪(水利署)
function reservior_info(){
	var reservior_object = {};
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/obs/reserviorobs",
		dataType: 'json',
		success: function (data) {
            raw_data["重要水庫"] = data;
        }
	}).done(function(reservior_data) {
		reservior_data.forEach(function(element){
			reservior_object[element.reservoir_identifier] = element;
		});
		var this_item_info =
			"石門水庫" + reservior_string(reservior_object["10201"]) + "、" +
			"翡翠水庫" + reservior_string(reservior_object["10205"]);
		$("#board_reservior, #live_broadcast_reservior").html(this_item_info);
		board_trig_unbing("#board_reservior");
		open_data_source('reservior')
	    $("#board_reservior").siblings("span").find("i").eq(1).click(function(){
	    	layer_remove();

	    	backgroud_layer_control("重要水庫");
	    	board_auto_fit();
	    });
		if (!this_item_info.match("無洩洪")) {
			$("#board_component_reservior").addClass("hightlight")
		} else {
			$("#board_component_reservior, #live_broadcast_reservior").removeClass("hightlight")
			// $("#live_broadcast_reservior").css("background-color", "#ffffff30")
		}
	});
}
function reservior_string(input){
	var status = String(parseInt(input.status_type));
	var cms = input.total_outflow;
	var result;
	switch(status){
		case "0":
			result = '<ct class="r_text">洩洪中</ct>';
			break;
		case "1":
			result = '<ct class="y_text">川流式</ct>';
			break;
		case "2":
			result = '<ct class="y_text">空庫排砂</ct>';
			break;
		case "3":
			result = '<ct class="y_text">自由溢流</ct>';
			break;
		case "4":
			result = '<ct class="y_text">調節性放水</ct>';
			break;
		case "5":
			result = '<ct class="y_text">預計放流</ct>';
			break;
		default:
			result = "無洩洪";
			break;
	};
	if (result != "無洩洪") {
		if (cms == null) {
			cms = 0;
		}
		result += "(流量" + parseInt(cms) + "cms)";
	}
	return result;
}
// 員山子分洪道(水利署)
function diviflow_info(){
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/obs/kyzobs",
		dataType: 'json',
		success: function (data) {
            raw_data["員山子分洪"] = data;
        }
	}).done(function(data) {
		var this_item_info = ""
		try {
			if (data[0].divi_flow > 0) {
				this_item_info = '<ct class="r_text">目前分洪中</ct>，分洪出流量為' + data[0].divi_flow + "cms";
			} else {
				this_item_info = '目前無分洪運作';
			}
		} catch (error) {
			this_item_info = '資料介接異常';
		}
		board_trig_unbing("#board_outflow");
		open_data_source('outflow')
		$("#board_outflow, #live_broadcast_outflow").html(this_item_info);
	    $("#board_outflow").siblings("span").find("i").eq(1).click(function(){
	    	layer_remove();
	    	backgroud_layer_control("員山子分洪");
	    	board_auto_fit();
	    });
		if (this_item_info !== "目前無分洪運作") {
			$("#board_component_outflow").addClass("hightlight")
		} else {
			$("#board_component_outflow").removeClass("hightlight")
			// $("#live_broadcast_outflow").css("background-color", "#ffffff30")
		}
	});

};
// 淹水警戒(水利署)
function flood_board_info(){
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/obs/floodwarn",
		dataType: 'json',
		success: function(data){
			try {
				var html_string = '', sum_1 = 0, sum_2 = 0, sum_3 = 0, list = {}, nowTimeUTC = get_now_time_UTC()
				data['entry'].forEach(function(element){
					if (!element.summary["#text"].includes("新北市")) return
					var timeDiff = (nowTimeUTC - time_sql_processing(element.updated)) / 3600000
					if (timeDiff <= 3) {
						var status
						switch(true){
							case (element.summary["#text"].match("一級") != null):
								sum_1 += 1
								status = "一級"
								break;
							case (element.summary["#text"].match("二級") != null):
								sum_2 += 1
								status = "二級"
								break;
						}
						html_string +=
							'<div class="mb-3">' +
								'<h4 class="font-weight-bold">*達到' + status +'淹水警戒</h4>' +
								'<h5>發布時間：' + element.updated.slice(0, 16) + '</h5>' +
								'<h5>說明：' + element.summary["#text"] + '</h5>' +
							'</div>'
					}
				})

				if (sum_1 > 0 || sum_2 > 0) {
					$("#board_flooding, #live_broadcast_flooding").html('<ct class="r_text">一級警戒' + sum_1 + '處</ct>、<ct class="y_text">二級警戒' + sum_2 + '處</ct>');
					$("#board_component_flooding").addClass("hightlight")
				} else {
					$("#board_flooding, #live_broadcast_flooding").html('目前無淹水警戒');
					$("#board_component_flooding").removeClass("hightlight")
					// $("#live_broadcast_flooding").css("background-color", "#ffffff30")
				}
				open_data_source('flooding')
				$("#board_flooding").siblings("span").find("i").eq(1).click(function(){
					if (html_string == "") { html_string = '目前無淹水警戒訊息！' }
					modal_open(html_string, "淹水警戒(水利署)詳細資訊");
				});
			} catch (error) {
				console.log(error)
				if (data.Warning == '限制存取間隔時間為3秒') {
					$("#board_flooding, #live_broadcast_flooding").html('目前無淹水警戒');
					$("#board_component_flooding").removeClass("hightlight")
				} else {
					$("#board_flooding, #live_broadcast_flooding").html("介接發生問題！");
				}
			}
		}
	})
	.fail(function(jqXHR, textStatus, errorThrown) {
		$("#board_flooding, #live_broadcast_flooding").html("介接發生問題！");
	})
}
// 停班停課(NCDR)
function banned_board_info(){
	// $.ajax({
	// 	headers: {
	// 		Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
	// 	},
	// 	url: publicPath + "/napi/obs/stopwork",
	// 	dataType: 'json',
	// 	success: function (data) {

    //     }
	// }).done(function(data) {
		// let text = data.split("。")[0].split("新北市:")[1]
	$("#board_ban, #live_broadcast_ban").html("目前正常上班上課");
		// $("#board_ban, #live_broadcast_ban").html("今日停止上班、停止上課");
		// var status = data;
		// if (status) {
		// 	if (status["停班停課"] == '目前正常上班上課') {
		// 		$('#board_component_ban').addClass('d-none')
		// 		$("#board_ban, #live_broadcast_ban").html(status["停班停課"]);
		// 		// $("#live_broadcast_ban").css("background-color", "#ffffff30")
		// 	} else {
		// 		$("#board_ban, #live_broadcast_ban").html(status["停班停課"]);
		// 	}
		// } else {
		// 	$("#board_ban, #live_broadcast_ban").html("介接異常");
		// }
	// });
}
// 道路封閉(公路總局)
function roadbreak_board_info(){
	const road_break_ncdr = ajax_call(publicPath + '/napi/obs/ncdr_cap_thb_road_break')
	if (road_break_ncdr.length == 0) {
		$("#board_road-break, #live_broadcast_road-break").html("目前無道路封閉");
		$("#board_component_road-break").addClass("d-none")
		// $("#live_broadcast_road-break").css("background-color", "#ffffff30")
	} else {
		$("#board_road-break").html("道路封閉" + road_break_ncdr.length + "處，可點擊表格按鈕檢視道路封閉詳細資訊");
		$("#live_broadcast_road-break").html("道路封閉" + road_break_ncdr.length + "處");
	}
	const road_break_ncdr_table = road_break_ncdr.map((el, index) =>
		`<tr class="road_break_ncdr_row">
			<td>${index + 1}</td>
			<td>${el.summary['#text']}</td>
			<td>${el.title}</td>
		</tr>`)
		// <td class="d-none" id="ncdr_row_latlng">${[Number(el.area.circle.slice(0,8)), Number(el.area.circle.slice(9,18))]}</td>
	// modal
	$("#board_road-break").siblings("span").find("i").eq(1).click(function(){
		modal_open(`
			<table class="table table-sm table-bordered mt-2">
				<thead class="thead-dark">
					<tr>
						<th>#</th>
						<th>道路封閉類型</th>
						<th>詳細說明</th>
					</tr>
				</thead>
				<tbody id="road-break-table">
				</tbody>
			</table>`,
			"道路封閉詳細資訊",
			() => {
				if (road_break_ncdr.length == 0) {
					$('#road-break-ncdr-table').html('<p>目前無道路封閉</p>')
				} else { $('#road-break-table').html(road_break_ncdr_table) }
			}
		)
	})

	$("#board_road-break").siblings("span").find("i").eq(1).click(function(){
		layer_remove();
		const road_break_ncdr_geojson = road_break_ncdr.map(el => {
			return {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [Number(el.area.circle.slice(0,8)), Number(el.area.circle.slice(9,18))].reverse()
				},
				"properties": el
			}
		})
		overlay_dataset['NCDR道路封閉'] = L.geoJSON(road_break_ncdr_geojson, {
			pointToLayer: (feature, latlng) => {
				const icon = L.icon({
					iconUrl: "marker_icon/road_break_ncdr.png",
					iconSize: [30, 30],
					iconAnchor: [0, 0],
					popupAnchor: [10, 10],
				})
				return L.marker(latlng, { icon })
			},
			onEachFeature: (feature, layer) => {
				layer.bindPopup(`
					<div style="width: 320px;">
						<h5 style="font-weight: 700">${feature.properties.area.areaDesc}</h5>
						<h6>說明：${feature.properties.description}</h6>
						<h6>生效時間：${feature.properties.effective.slice(0, 19).replace('T', ' ')}</h6>
						<h6>到期時間：${feature.properties.expires.slice(0, 19).replace('T', ' ')}</h6>
					</div>
				`)
			}
		})
		map.addLayer(overlay_dataset['NCDR道路封閉'])
		board_auto_fit();
	})
}
// 維生管線(EMIC)
function infrastructure_board_info(){
	var labelMapping = { electricity: "斷電", gas: "斷氣", phone: "斷訊", water: "斷水" }
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/obs/emicpipebreak",
		dataType: 'json',
		timeout: 5000,
		success: function (data) {
			var result = {},
				keyMapping = {
					electricity: ["electro_dmg_now", "electro_dmg_used", "town_name"],
					gas: ["gas_damage_now", "gas_damage_used", "town_name"],
					phone: ["town_name", "phone_damage_total", "phone_fixed"],
					water: ["water_dmg", "water_recvy", "town_name"]
				},
				html = ""
			for (var each in data) {
				var sub_html = {
					status: "",
					source: "",
					detailed: "",
					content: ""
				}
				if (data[each] == "fail") {
					keyMapping[each].forEach(function(key){
						if (key != "town_name") {
							result[each][key] = 0
						} else {
							result[each][key] = ""
						}
					})
					sub_html.status = "來源端資料異常。"
				} else {
					var ntcData = data[each].detail.filter(function(element){
						return element.city_name == "新北市"
					})
					result[each] = {}
					if (ntcData.length == 0) {
						keyMapping[each].forEach(function(key){
							if (key != "town_name") {
								result[each][key] = 0
							} else {
								result[each][key] = ""
							}
						})
						sub_html.detailed = "<li>無資訊</li>"
					} else {
						ntcData.forEach(function(element){
							keyMapping[each].forEach(function(key){
								if (result[each][key] == undefined) {
									if (key != "town_name") {
										result[each][key] = 0
									} else {
										result[each][key] = ""
									}
								}
								if (key != "town_name") {
									result[each][key] += parseInt(element[key])
								} else {
									if (element[key] != null) {
										result[each][key] += "、" + element[key]
									}
								}
							})
						})
						Object.keys(ntcData[0]).forEach(key => {
							sub_html.detailed += `<li>${data[each].detailcmt[key]}：${null_Converter(ntcData[0][key])}</li>`
						})
					}
					Object.keys(data[each].main).forEach(key => {
						sub_html.source += `<li>${data[each].maincmt[key]}：${null_Converter(data[each].main[key])}</li>`
					})
					sub_html.content = `
						<ul>
							<li>填報資訊</li>
							<ul>
								${sub_html.detailed}
							</ul>
							<li>填報來源</li>
							<ul>
								${sub_html.source}
							</ul>
						</ul>`
				}
				html += `
					<ul>
						<li>${labelMapping[each]}${sub_html.status}</li>
						${sub_html.content}
					</ul>`
			}
			let result_sum = result.electricity.electro_dmg_now + result.water.water_dmg + result.phone.phone_damage_total + result.gas.gas_damage_now
			if (result_sum == 0) {
				$('#board_component_flash').addClass('d-none')
			}
			$("#board_flash, #live_broadcast_flash").html(
				'電(<i class="fas fa-times"></i>' + result.electricity.electro_dmg_now + '戶/<i class="fas fa-wrench"></i>' + result.electricity.electro_dmg_used +
				'戶)、水(<i class="fas fa-times"></i>' + result.water.water_dmg + '戶/<i class="fas fa-wrench"></i>' + result.water.water_recvy +
				'戶)、訊(<i class="fas fa-times"></i>' + result.phone.phone_damage_total + '戶/<i class="fas fa-wrench"></i>' + result.phone.phone_fixed +
				'戶)、氣(<i class="fas fa-times"></i>' + result.gas.gas_damage_now + '戶/<i class="fas fa-wrench"></i>' + result.gas.gas_damage_used + '戶)'
			)
			open_data_source('flash')
			$("#board_flash").siblings("span").find("i").eq(1).click(function(){
				modal_open(html, "維生管線(EMIC)詳細資訊");
			})
        }
	}).fail(function(jqXHR, textStatus, errorThrown){
		$("#board_flash, #live_broadcast_flash").html("介接發生問題！");
	});
}

// 二維淹水模擬
function ntu2d_list_info(){
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/simulate/floodntusimulation",
		dataType: 'json',
		success: function (data) {
            raw_data["台大二維淹水模擬結果"] = data;
        }
	}).done(function(data) {
		var now_list_length = $("#prediction_flood_selector option").length,
			now_list_target = $("#prediction_flood_selector").val(),
			now_data_length = Object.keys(data).length + 4;
		if ((now_list_target != undefined) && (now_data_length > now_list_length)) {
			var data_key = Object.keys(data).reverse(),
				list_option_html = '';
			data_key.forEach(function(element){
				var this_value = element + ",dynamic",
					selected_option = "";
				if (this_value == now_list_target) {
					selected_option = " selected"
				}
		    	list_option_html += '<option' + selected_option + ' value="' + this_value + '">' + ntu2d_time_converter(this_value) + '(台大) 網格數：' + data[element] + '個</option>';
			})
			$("#prediction_flood_selector").html(
				'<option value="200,potential">24小時內降雨200mm(水利署)</option>' +
				'<option value="350,potential">24小時內降雨350mm(水利署)</option>' +
				'<option value="450,potential">24小時內降雨450mm(水利署)</option>' +
				'<option value="600,potential">24小時內降雨600mm(水利署)</option>' +
				list_option_html
			)
			toast_open("已有最新台大二維淹水模擬預報結果！")
		}
	})
}
// CCTV 狀態
// function cctv_status_info(){
// 	$.ajax({
// 		url: publicPath + "/cloud/edp2/cctv_status_json/",
// 		dataType: 'json',
// 		success: function (data) {
// 			var object = {};
// 			data.forEach(function(element){
// 				object[element.name] = element;
// 			});
// 			raw_data["CCTV狀態"] = object;
//         }
//     });
// }
// 雨水下水道
function sewer_board_info(){
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/flood/sewer_sensor_list",
		dataType: 'json',
		success: function (data) {
            raw_data["雨水下水道"] = create_sewer_sensor_geojson(data.data);
        }
	}).done(function(data) {
		try {
			var tbody_string = "",
				sum = {
					none: 0
				}
			data.data.forEach(el => {
				tbody_string += `
					<tr>
						<td>${el.townname}</td>
						<td>${el.villname}</td>
						<td>${el.address}</td>
						<td>${String(el.h3)}m</td>
						<td>${String(el.h2)}m</td>
						<td>${String(el.h1)}m</td>
						<td>-</td>
						<td>-m</td>
						<td>離線</td>
					</tr>`
				sum.none += 1
			})
			$("#board_sewer").html(`<ct class="r_text">溢出路面0處</ct>、<ct class="r_text">滿管0處</ct>、<ct class="y_text">半滿管0處</ct>、未達警戒0處、<ct class="gray_text"離線${sum.none}處</ct>`)
			board_trig_unbing("#board_sewer");
			$("#board_sewer").siblings("span").find("i").eq(1).click(function(){
				modal_open_table(
					"雨水下水道測站快速一覽表",
					"<th>行政區</th><th>村里</th><th>測站名</th><th>溢出路面</th><th>滿管</th><th>半滿管</th><th>觀測時間</th><th>觀測水位</th><th>狀態</th>",
					tbody_string,
					0
				)
			})
			$("#board_sewer").siblings("span").find("i").eq(2).click(function(){
				layer_remove()
				backgroud_layer_control("雨水下水道")
				board_auto_fit()
			});
		} catch (e) {
			$("#board_sewer").html("介接資料異常！");
		}
	})
}

// 車行地下道水位監測
function underpass_water_board_info(){
	let sum_no_alert = 0;
	let sum_puddle = 0;
	let sum_flood = 0;
	let sum_offline = 0;
	let thead_string = '';
	let tbody_string = '';
	$.ajax({
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
		},
		url: publicPath + "/napi/underpass",
		dataType: 'json',
		success: function (data) {
			raw_data["車行地下道水位監測"] = data;
		}
	}).done(function(data) {
		try {
			data.forEach(function(element){
				// Check if data is older than 2 hours
				const time_lag = new Date().getTime() - new Date(element.update_time).getTime();
				let floodLevelHTML = '';

				if (time_lag > 3600000 * 2) {
					// Offline if not updated for more than 2 hours
					floodLevelHTML = '<span class="gray_text">離線</span>';
					sum_offline++;
				} else {
					// Determine flood level text and color based on flood_level
					switch(element.flood_level) {
						case 0:
							floodLevelHTML = '<span class="gray_text">無淹水</span>';
							sum_no_alert++;
							break;
						case 1:
							floodLevelHTML = '<span class="y_text">積水<10cm</span>';
							sum_puddle++;
							break;
						case 2:
							floodLevelHTML = '<span class="y_text">積水10~20cm</span>';
							sum_puddle++;
							break;
						case 3:
							floodLevelHTML = '<span class="r_text">淹水>20cm</span>';
							sum_flood++;
							break;
						default:
							floodLevelHTML = '<span>-</span>';
					}
				}

				tbody_string +=
					'<tr>' +
						'<td>' + (element.district || '-') + '</td>' +
						'<td>' + (element.name || '-') + '</td>' +
						'<td>' + (element.description || '-') + '</td>' +
						'<td>' + (element.update_time ? element.update_time.slice(0,16) : '-') + '</td>' +
						'<td>' + (element.gage_height !== undefined ? element.gage_height + 'cm' : '-') + '</td>' +
						'<td>' + floodLevelHTML + '</td>' +
					'</tr>';
			});

			$("#board_underpass, #live_broadcast_underpass").html(`
				<ct class="r_text" id="board_underpass_flood">淹水${sum_flood}處</ct>、
				<ct class="y_text" id="board_underpass_puddle">積水${sum_puddle}處</ct>、
				<ct id="board_underpass_no_alert">未達警戒${sum_no_alert}處</ct>、
				<ct class="gray_text" id="board_underpass_offline">離線${sum_offline}處</ct>
			`);

			// Bind click events for each status category
			$("#board_underpass_flood, #board_underpass_puddle, #board_underpass_no_alert, #board_underpass_offline").click((e) => {
				layer_remove();
				let status = ''
				switch (e.target.id) {
					case 'board_underpass_flood':
						status = '淹水'
						break
					case 'board_underpass_puddle':
						status = '積水'
						break
					case 'board_underpass_no_alert':
						status = '未達警戒'
						break
					case 'board_underpass_offline':
						status = '離線'
						break
				}
				let result = layer_underpass_water(status)
				overlay_dataset['filteredLayer'] = result[0]
				map.addLayer(overlay_dataset['filteredLayer'])
			})

			thead_string =
				'<th>行政區</th>' +
				'<th>地下道名稱</th>' +
				'<th>說明</th>' +
				'<th>觀測時間</th>' +
				'<th>水位高度</th>' +
				'<th>淹水程度</th>';

			board_trig_unbing("#board_underpass");
			open_data_source('underpass')

			// Table view button
			$("#board_underpass").siblings("span").find("i").eq(1).click(function(){
				modal_open_table("車行地下道水位監測快速一覽表", thead_string, tbody_string, 0);
			})

			// Map layer button
			$("#board_underpass").siblings("span").find("i").eq(2).click(function(){
				layer_remove();
				backgroud_layer_control("淹水感知器(車行地下道)");
				board_auto_fit();
			});

			// Highlight board component if there are any alerts
			if (sum_flood > 0 || sum_puddle > 0) {
				$("#board_underpass").addClass("hightlight")
			} else {
				$("#board_underpass").removeClass("hightlight")
			}
		} catch (e) {
			console.error('Error in underpass_water_board_info:', e)
			$("#board_underpass").html("介接資料異常！");
		}
	})
}